var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "30px",
    viewBox: "0 0 50 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service-Only-Purchase-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Service-Purchase---Digital-Only---Payment-Error",
    transform: "translate(-110.000000, -822.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-Methods",
    transform: "translate(40.000000, 734.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(33.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa-dark",
    transform: "translate(37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#26337A",
    x: 0,
    y: 0,
    width: 50,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#FFFFFE",
    points: "20.7449954 19.7733803 22.2823641 10.236338 24.7397926 10.236338 23.2025645 19.7733803 20.7449954 19.7733803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1164355,10.4704225 C31.6305438,10.2790141 30.8663571,10.0702817 29.9143917,10.0702817 C27.4847926,10.0702817 25.7745438,11.364507 25.7603479,13.2177465 C25.7448871,14.5885915 26.9807696,15.3530986 27.9124954,15.8087324 C28.8700829,16.2757746 29.1918088,16.5746479 29.1880138,16.9922535 C29.1814078,17.6309859 28.4236866,17.923662 27.7171267,17.923662 C26.7332558,17.923662 26.2105392,17.7795775 25.4023594,17.4235211 L25.0862558,17.2716901 L24.7426037,19.4064789 C25.3156382,19.6721127 26.3779378,19.9026761 27.4804355,19.9147887 C30.0625346,19.9147887 31.7403157,18.6361972 31.7599931,16.6571831 C31.7688479,15.5701408 31.1140115,14.7461972 29.6958318,14.0659155 C28.837053,13.623662 28.3099793,13.3307042 28.316023,12.8830986 C28.3165853,12.4867606 28.7612949,12.0623944 29.7238018,12.0623944 C30.5276244,12.0494366 31.1095138,12.2350704 31.5629378,12.4288732 L31.783606,12.5378873 L32.1164355,10.4704225",
    id: "Fill-4",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3886498,16.3921127 C35.5923111,15.8439437 36.3676014,13.726338 36.3676014,13.726338 C36.353265,13.7515493 36.5701382,13.1739437 36.6942465,12.8164789 L36.8600991,13.6390141 C36.8600991,13.6390141 37.3316544,15.9153521 37.4287765,16.3921127 L35.3886498,16.3921127 L35.3886498,16.3921127 Z M38.4203779,10.2460563 L36.5212258,10.2460563 C35.9321682,10.2460563 35.4912535,10.4147887 35.2331982,11.0366197 L31.5837396,19.7767606 L34.1648548,19.7767606 C34.1648548,19.7767606 34.5859516,18.6009859 34.6815276,18.3429577 C34.9630553,18.3429577 37.4710829,18.3478873 37.8290714,18.3478873 C37.9027212,18.6807042 38.1283088,19.7767606 38.1283088,19.7767606 L40.4092028,19.7767606 L38.4203779,10.2460563 L38.4203779,10.2460563 Z",
    id: "Fill-5",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6833641,10.2443662 L16.2780806,16.746338 L16.020447,15.4246479 C15.5722235,13.901831 14.1769539,12.2512676 12.6162535,11.4242254 L14.8167512,19.7650704 L17.4175438,19.7635211 L21.28753,10.2443662 L18.6833641,10.2443662",
    id: "Fill-6",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0452558,10.2378873 L10.0823641,10.2378873 L10.0497558,10.435493 C13.1333479,11.225493 15.1736152,13.1323944 16.020447,15.4246479 L15.1592788,11.0425352 C15.0107143,10.438169 14.5789355,10.2590141 14.0452558,10.2378873",
    id: "Fill-7",
    fill: "#EC982D"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/icon_Visa.11de2975.svg";
export { ForwardRef as ReactComponent };